import Cookies from 'js-cookie'
import match from 'js-pattern-matching'

const getEnv = require('../../get-env')

function getOption() {
  const ENV = getEnv()
  return match(ENV)(
    (v = 'dev') => ({}),
    (v = 'test') => ({ domain: '.cds8.cn' }),
    (v = 'stage') => ({ domain: '.cds8.cn' }),
    (v = 'prod') => ({ domain: '.chanjian.cc' })
  )
}

export function sc(k, v) {
  const ENV = getEnv()
  if (ENV === 'prod') {
    // 设置主域名的 cookie
    Cookies.set(k, v, { ...getOption() })
    // 设置 chanxuan.com 的跨域 cookie
    Cookies.set(k, v, {
      domain: '.chanxuan.com',
      sameSite: 'None',
      secure: true,
      path: '/',
      crossDomain: true
    })
  } else {
    Cookies.set(k, v, { ...getOption() })
  }
}

export function gc(k) {
  return Cookies.get(k, { ...getOption() })
}

export function getPromotionCode() {
  const promotionCode = gc('PROMOTE_CODE')
  if (promotionCode) {
    return promotionCode
  }
  return ''
}

export function sls(k, v) {
  localStorage.setItem(k, JSON.stringify(v))
}

export function rls(k) {
  localStorage.removeItem(k)
}

export function gls(k) {
  try {
    const item = localStorage.getItem(k)
    if (!item) {
      return null
    }
    return JSON.parse(item)
  } catch (e) {
    console.log(e)
    return null
  }
}

export function esls(k, v, t = 3600) {
  const tiem = new Date().getTime() + t * 1000
  localStorage.setItem(k, JSON.stringify([v, tiem]))
}

export function egls(k) {
  const time = new Date().getTime()
  const item = localStorage.getItem(k)
  if (!item) {
    return null
  }
  const [v, t] = JSON.parse(item)
  if (time > t) {
    rls(k)
    return null
  } else {
    return v
  }
}

export function sss(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value))
}

export function gss(key) {
  const item = sessionStorage.getItem(key)
  if (!item) {
    return null
  }
  return JSON.parse(item)
}

export const myLocalStorage = {
  set(namespace = 'visitPlanList', key, data, time) {
    const storage = JSON.parse(localStorage.getItem(namespace)) || {}
    storage[key] = {
      data,
      createTime: Date.now(),
      lifeTime: time || 1000 * 60 * 60 * 24 * 7 // 默认设置过期时间：7天
    }
    localStorage.setItem(namespace, JSON.stringify(storage))
  },
  get(namespace = 'visitPlanList', key) {
    const storage = JSON.parse(localStorage.getItem(namespace)) || {}
    if (!storage[key]) return
    const { data, createTime, lifeTime } = storage[key]
    // 当前时间 - 存入时间 > 过期时间
    if (Date.now() - createTime > lifeTime) {
      delete storage[key]
      localStorage.setItem(namespace, JSON.stringify(storage))
      return null
    } else {
      return data
    }
  },
  delete(namespace = 'visitPlanList', key) {
    const storage = JSON.parse(localStorage.getItem(namespace)) || {}
    if (!storage[key]) return
    delete storage[key]
    localStorage.setItem(namespace, JSON.stringify(storage))
  }
}
